export default __webpack_public_path__ + "NdelBuild/static/media/ap-bg-pageConfirmation.jpg";